import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Spin, Table } from 'antd';
import { axiosErrorHandler } from '../../../../../swzutils';
import HasPermissions from "../../../../../containers/HasPermissions";
import TimeSlotModal from "./TimeSlotModal";
import { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import TenantTimeSlotGroupResource from "../api/TenantTimeSlotGroupResource";
const TabTimeSlots = ({ tenantId }) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [timeSlotGroups, setTimeSlotGroups] = useState([]);
    const [editTimeSlotGroup, setEditTimeSlotGroup] = useState(undefined);
    const [modal, contextHolder] = Modal.useModal();
    useEffect(() => {
        loadTenantTimeSlotGroups();
    }, [tenantId]);
    const loadTenantTimeSlotGroups = () => {
        setShowSpinner(true);
        TenantTimeSlotGroupResource.search(tenantId, setTimeSlotGroups, axiosErrorHandler, () => setShowSpinner(false));
    };
    const onTimeSlotGroupDeleted = (timeSlotGroup) => {
        setTimeSlotGroups(timeSlotGroups.filter(tsGrp => tsGrp.id != timeSlotGroup.id));
    };
    const confirmDelete = (timeSlotGroup) => {
        modal.confirm({
            title: 'Are you sure?',
            content: 'Delete time slot group "' + timeSlotGroup.name + '"',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
                TenantTimeSlotGroupResource.delete(tenantId, timeSlotGroup.id, () => onTimeSlotGroupDeleted(timeSlotGroup), axiosErrorHandler, () => setModalVisible(false));
            }
        });
    };
    const add = () => {
        setModalVisible(true);
        setEditTimeSlotGroup(undefined);
    };
    const edit = (editTimeSlotGroup) => {
        setModalVisible(true);
        setEditTimeSlotGroup(editTimeSlotGroup);
    };
    const onTimeSlotAddedOrUpdated = ( /*timeSlot*/) => {
        setModalVisible(false);
        setEditTimeSlotGroup(undefined);
        loadTenantTimeSlotGroups();
    };
    const onModalCancel = () => {
        setModalVisible(false);
    };
    const timeSlotColumns = [{
            title: 'Name',
            dataIndex: 'name',
            width: '25%'
        }, {
            title: 'Vehicle Types',
            dataIndex: 'vehicleTypes',
            width: '50%',
            render: (text, record) => {
                if (record.vehicleTypes?.length) {
                    return record.vehicleTypes.map(vt => {
                        return _jsxs(_Fragment, { children: [vt.description, _jsx("br", {})] });
                    });
                }
                else {
                    return "-";
                }
            }
        }, {
            title: 'Action',
            key: 'action',
            className: 'centre',
            width: '25%',
            render: (text, record) => (_jsxs("span", { className: "actions", children: [_jsx(HasPermissions, { permissions: ['admin:tenant:timeSlot:update'], children: _jsx(Button, { onClick: () => edit(record), icon: _jsx(EditOutlined, {}), children: "Edit" }) }), "\u00A0", _jsx(HasPermissions, { permissions: ['admin:tenant:timeSlot:delete'], children: _jsx(Button, { onClick: () => confirmDelete(record), icon: _jsx(DeleteOutlined, {}), children: "Delete" }) })] }))
        }];
    return (_jsxs(Spin, { spinning: showSpinner, children: [contextHolder, _jsxs(Card, { title: "Time Slot Groups", type: "inner", variant: 'borderless', children: [_jsxs("div", { className: "table-operations-inline", children: [_jsx(Button, { className: "pull-right", onClick: loadTenantTimeSlotGroups, title: "Refresh", icon: _jsx(ReloadOutlined, {}) }), _jsx(Button, { onClick: add, icon: _jsx(PlusOutlined, {}), children: "Add an Time Slot Group" })] }), _jsx(Table, { columns: timeSlotColumns, size: "middle", rowKey: record => record.id, dataSource: timeSlotGroups, pagination: false })] }), _jsx(TimeSlotModal, { open: modalVisible, tenantId: tenantId, editTimeSlotGroup: editTimeSlotGroup, onAddedOrUpdated: onTimeSlotAddedOrUpdated, onCancel: onModalCancel })] }));
};
export default TabTimeSlots;
